import { styled } from "@linaria/react"

import { InviteMedium } from "@/icons/Icons.ts"

export const InviteTeammatesButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  color: var(--main-color);
  background: var(--main-color-10);

  &:hover:not(:disabled) {
    background: var(--main-color-15)
  }

  padding: 8px 16px;

  cursor: pointer;
  border-radius: var(--border-radius-20);
`

export const InviteTeammatesButtonIcon = styled(InviteMedium)`
  opacity: 0.6;
`